import * as React from 'react'
import { IO, pipe, RA, RD } from '@packages/prelude'
import * as domain from '@packages/domain'
import { type NameItem } from '~/components/NameSelector'
import { useApi } from '~/api'

export const useAvailableNames = (
  productId: number,
  hasPreRecorded: boolean
): RD.RemoteData<domain.Error.Type, ReadonlyArray<NameItem>> => {
  const [loadNamesQuery, namesRequest] = useApi(domain.Api.NameCatalog.loadNames)

  React.useEffect(() => {
    // launching the (fire-and-forget) names query is itself the IO we gate on hasPreRecorded
    const load: IO.IO<void> = () => {
      loadNamesQuery({ productId })()
    }
    pipe(load, IO.when(hasPreRecorded))()
  }, [hasPreRecorded, productId, loadNamesQuery])

  return React.useMemo(
    () =>
      pipe(
        namesRequest,
        RD.map(({ names }) =>
          pipe(
            names,
            RA.mapWithIndex((id, name) => ({ id, name }))
          )
        )
      ),
    [namesRequest]
  )
}
